var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { attrs: { title: _vm.title } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", { attrs: { src: require("@/assets/img/logo.png"), alt: "" } })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("surveyProblem", {
          attrs: { problem: _vm.currentProblem, seq: _vm.seq },
          on: { change: _vm.changeOptions }
        }),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "van-overlay loading" },
              [_c("van-loading")],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer flex" }, [
      _vm.currentProblem.id && _vm.currentProblem.isOrFirst !== "0"
        ? _c(
            "div",
            { staticClass: "secondary item1", on: { click: _vm.previous } },
            [_vm._v("\n      上一题\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentProblem.id && _vm.currentProblem.isOrFirst !== "1"
        ? _c("div", { staticClass: "primary item1", on: { click: _vm.next } }, [
            _vm._v("\n      下一题\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentProblem.id && _vm.currentProblem.isOrFirst === "1"
        ? _c(
            "div",
            { staticClass: "primary item1", on: { click: _vm.submit } },
            [_vm._v("\n      提交\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.currentProblem.id
        ? _c(
            "div",
            {
              staticClass: "primary item1",
              on: { click: _vm.redirectClientDetail }
            },
            [_vm._v("\n      退出\n    ")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7f8f4be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7f8f4be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/submitSurvey.vue
// module id = null
// module chunks = 